import { apiGet } from "../client";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { IExamProgress } from "./types";

export const getExamProgress = async (id: string) => {
  const response = await apiGet<IExamProgress>(`/exam_progress/${id}`);
  return response.data;
};

export const useQueryGetExamProgress = (id: string) => {
  return useQuery({
    queryKey: QueryKeys.examProgress.detail(id),
    queryFn: () => getExamProgress(id),
    enabled: !!id,
  });
};
